import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import initialState from './organizationInstitutionInitialState';
import {
  _setPrisonCode,
  _setPrisonNumber,
  _setInstitutionGender,
} from './organizationInstitutionActions';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getOrganizationInstitutionForm = createAsyncThunk(
  'stop/getOrganizationInstitutionForm',
  async (params) => {
    const { commonParams, authorization } = params;
    const config = {
      headers: {
        Authorization: authorization,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(commonParams, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });

    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const organizationInstitutionSlice = createSlice({
  name: 'stop/organizationInstitutionForm',
  initialState,
  reducers: {
    setPrisonCode: _setPrisonCode,
    setPrisonNumber: _setPrisonNumber,
    setInstitutionGender: _setInstitutionGender,
    resetOrganizationInstitutionForm: (state) => initialState,
  },
  extraReducers: {
    [getOrganizationInstitutionForm.fulfilled]: (state, action) =>
      action.payload,
  },
});

export const {
  setPrisonCode,
  setPrisonNumber,
  setInstitutionGender,
  resetOrganizationInstitutionForm,
} = organizationInstitutionSlice.actions;

export default organizationInstitutionSlice.reducer;
